// config file to maintain all the service end points

export const URLConfig: { [key: string]: string } = {
  accountLookUp: 'account/lookup',
  validateAccount: 'account/validate',
  accountDetails: 'account/details',
  accountDetailsAuth: 'accounts',
  validateZipCode: 'zipcode/validate',
  ZipCodeDetails: 'zipcode/details',
  apartmentLookUp: 'address/units',
  addressList: 'address/streets',
  workDays: 'service/workdays',
  opCoWorkDays: '/workdays',
  addressLookUp: 'address/lookup',
  submitService: 'service/residential/move',
  addressVerification: 'start/address/availability',
  stopScheduleURL: 'stop/address/availability',
  startService: 'service/residential/start',
  ptfdFlagCheck: 'start/check/ptfd',
  stopService: 'service/residential/stop',
  loginPageURL: '/Pages/Login.aspx',
  registerUrl: '/Pages/AnonRedirect.aspx?Destination=/Pages/UserRegistrationLanding.aspx',
  validBankURL: 'bank',
  storePrefs: 'start/store/prefs',
  enrollment: 'start/autopay/enroll',
  outageStatusUrl: '/MyAccount/MyBillUsage/pages/secure/Check-My-Outage-Status.aspx',
  enrollOutageUrl: '/Outages/CheckOutageStatus/pages/EnrollOutage.aspx',
  preferenceCenterUrl: '/MyAccount/MyProfile/Pages/Secure/PreferenceCenter.aspx?sectionNav=Outage',
  bgePreferenceCenterUrl: '/MyAccount/MyProfile/pages/secure/NotificationPreferences.aspx?sectionNav=Outage',
  myBillUsageUrl: '/MyAccount/MyBillUsage/pages/secure/MyBillUsage.aspx',
  defaultPageUrl: '/Pages/default.aspx',
  registerAnon: '/Pages/UserRegistrationLanding.aspx',
  EUCOMSReportAnOutageUrl: '/Outages/ReportAnOutage/Pages/ReportAnOutage.aspx',
  viewOutageTrackerUrl: '/powerOutages/outageTracker/dashboard',
  accountLookUpToolUrl: '/accounts/registration/account-lookup/by-personal',
};
